import { StoreType } from 'store/root';

export const getReportPaymentReceiptSelector = (store: StoreType) => {
	return store.reportStore.receipt;
};
